import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const VehicleSpeedRpmGuidePage = () => <DataDrivenGuidePage slug="guide-vehicle-speed-rpm" />;

export default VehicleSpeedRpmGuidePage;
